import { basicVehicleTableHeaders } from './constants';

export const rowTitle = (id: string) => {
  return basicVehicleTableHeaders.find((h) => h.id === id)?.label;
};
